module.exports = __webpack_public_path__ + "img/9303c31.jpg";